(function () {
  function parseVariantsScript(cardRoot) {
    const script = cardRoot.querySelector('script[data-related-compact-variants]');
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariant(data, id) {
    const vid = String(id);
    return data.variants.find((v) => String(v.id) === vid);
  }

  function buildPriceHtml(v, item) {
    const reg = item.dataset.i18nRegular || '';
    const sale = item.dataset.i18nSale || '';
    const soldClass = v.available ? '' : ' price--sold-out';
    if (v.compare_at_html) {
      return (
        '<div class="price product-related-compact__price-el price--on-sale' +
        soldClass +
        '">' +
        '<div class="price__container">' +
        '<div class="price__sale">' +
        '<span class="visually-hidden">' +
        reg +
        '</span>' +
        '<span><s class="price-item price-item--regular">' +
        v.compare_at_html +
        '</s></span>' +
        '<span class="visually-hidden">' +
        sale +
        '</span>' +
        '<span class="price-item price-item--sale price-item--last">' +
        v.price_html +
        '</span>' +
        '</div></div></div>'
      );
    }
    return (
      '<div class="price product-related-compact__price-el' +
      soldClass +
      '">' +
      '<div class="price__container">' +
      '<div class="price__regular">' +
      '<span class="visually-hidden">' +
      reg +
      '</span>' +
      '<span class="price-item price-item--regular">' +
      v.price_html +
      '</span>' +
      '</div></div></div>'
    );
  }

  function onVariantSelectChange(ev) {
    const select = ev.target;
    if (!select.matches('.product-related-compact__variant-select')) return;

    const item = select.closest('.product-related-compact__item');
    if (!item) return;

    const data = parseVariantsScript(item);
    if (!data || !data.variants) return;

    const variant = findVariant(data, select.value);
    if (!variant) return;

    const priceEl = item.querySelector('[data-related-compact-price]');
    if (priceEl) {
      priceEl.innerHTML = buildPriceHtml(variant, item);
    }

    const idInput = item.querySelector('[data-related-compact-variant-id]');
    if (idInput) {
      idInput.value = variant.id;
      idInput.removeAttribute('disabled');
    }

    const submit = item.querySelector('[data-related-compact-submit]');
    const label = item.querySelector('[data-related-compact-submit-label]');
    const addText = submit && submit.dataset.addLabel;
    const soldOutText = submit && submit.dataset.soldOutLabel;
    const ariaAdd = submit && submit.dataset.ariaAdd;
    const ariaSold = submit && submit.dataset.ariaSold;

    const canBuy = variant.available && !variant.draft;
    if (submit) {
      submit.disabled = !canBuy;
      submit.removeAttribute('aria-disabled');
    }
    if (canBuy) {
      if (label) {
        label.removeAttribute('hidden');
        label.textContent = addText || '';
      }
      if (submit && ariaAdd) submit.setAttribute('aria-label', ariaAdd);
    } else {
      if (label) {
        label.removeAttribute('hidden');
        label.textContent = soldOutText || '';
      }
      if (submit && ariaSold) submit.setAttribute('aria-label', ariaSold);
    }

    const baseUrl = item.dataset.productBaseUrl;
    if (baseUrl) {
      try {
        const u = new URL(baseUrl, window.location.origin);
        u.searchParams.set('variant', String(variant.id));
        const pathAndQuery = u.pathname + u.search;
        item.querySelectorAll('a.product-related-compact__media, a.product-related-compact__title').forEach((a) => {
          a.href = pathAndQuery;
        });
      } catch (e) {
        /* ignore */
      }
    }
  }

  document.addEventListener('change', onVariantSelectChange);
})();

